import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { SideMenu } from '@app/models/side-menu';
import { menuGeneric } from '@app/utils/menu';
import { TranslateModule } from '@ngx-translate/core';
import { MegaMenuItem } from 'primeng/api';
import { AvatarModule } from 'primeng/avatar';

@Component({
  selector: 'zero-waste-side',
  templateUrl: './side.component.html',
  standalone: true,
  imports: [
    RouterLink,
    CommonModule,
    AvatarModule,
    TranslateModule,
    RouterLinkActive,
  ],

  styleUrls: ['./side.component.scss'],
})
export class SideComponent implements OnInit {
  items!: MegaMenuItem[];
  avatar: string = 'MON';
  sideMenu: SideMenu[] = [];

  constructor() {
    this.initSideMenu();
  }

  ngOnInit() {}
  private initSideMenu(): void {
    this.sideMenu = menuGeneric();
  }

  logout() {}
}
